<template>
  <div
    :class="[isRead ? 'choice' : 'choices']"
    v-if="topicData"
    class="doubleChoice"
  >
    <!-- <div class="wrap" > -->
    <div class="leftChoice" v-html="topicData.topic.title"></div>
    <div class="rightChoice">
      <div
        class="ask_title"
        v-html="
          topicData.topic.stem
            ? topicData.topic.stem.replace(/\n/g, '<br>')
            : ''
        "
      ></div>
      <div class="choiceT">
        <el-table :data="tableData" border>
          <el-table-column prop="english" width="70"></el-table-column>
          <el-table-column
            :label="topicData.topic.yes"
          >
            <template slot-scope="scope">
              <el-checkbox
                border
                v-model="answer.firstRadio"
                @change="radioChange"
                :label="scope.$index"
                >{{ "" }}
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            :label="topicData.topic.no"
          >
            <template slot-scope="scope">
              <el-checkbox
                border
                v-model="answer.secondRadio"
                @change="radioChange"
                :label="scope.$index"
                >{{ "" }}
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="value" ></el-table-column>
        </el-table>
      </div>
      <div style="height: 100px"></div>
    </div>

    <!-- </div> -->
  </div>
</template>

<script>
import api from "@/api/dryRun.js";
export default {
  data() {
    return {
      tableData: [],
      english: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      // 答案
      answer: {
        firstRadio: [],
        secondRadio: [],
      },
      topicData: null, //题数据
      //阅读控制
      isRead: true,
    };
  },
  watch: {
    answer: {
      handler(val) {
        if (val.firstRadio.length == 1 && val.secondRadio.length == 1) {
          sessionStorage.setItem("isAnswer", true);
        } else {
          sessionStorage.setItem("isAnswer", false);
        }
        const value = [];
        for (const v of val.firstRadio) {
          value.push(v * 2);
        }
        for (const v of val.secondRadio) {
          value.push(v * 2 + 1);
        }
        sessionStorage.setItem("answer", JSON.stringify(value));
      },
      deep: true,
    },
  },
  async created() {
    console.log(sessionStorage.setItem("isAnswer", false));
    if (sessionStorage.getItem("examType") === "练习") {
      if (sessionStorage.getItem("isFirst") === "true") {
        this.startExercise();
      } else {
        this.nextExerciseTopic();
      }
    } else {
      if (sessionStorage.getItem("review") === "true") {
        this.getMockexam();
      } else if (sessionStorage.getItem("isFirst") === "true") {
        await this.startAnswer();
      } else {
        let params = {
          id: sessionStorage.getItem("curId"),
          m_id: sessionStorage.getItem("m_id"),
        };
        const res = await api.next(params);
        console.log("下一题", res);
        // 阅读题判断
        const isRead = res.data.data.c_id;
        if (isRead == 9) {
          this.isRead = false;
        }
        if (res.data.code === 0) {
          this.info(res);
        }
      }
    }
  },
  methods: {
    info(res) {
      this.topicData = res.data.data;
      this.tableData = this.topicData.topic.answer.map((item, index) => {
        return {
          english: this.english[index],
          value: item,
        };
      });
      console.log(this.tableData);
      let nums = this.topicData.index;
      const q_id = this.topicData.topic.id;
      if (this.topicData.sortlist) {
        for (const item of this.topicData.sortlist) {
          if (item.indexOf(q_id) > -1) {
            nums = item.indexOf(q_id) + 1;
          }
        }
      }
      sessionStorage.setItem("mark", this.topicData.mark);
      sessionStorage.setItem("q_id", q_id);
      sessionStorage.setItem("collect", this.topicData.topic.collect);
      sessionStorage.setItem("nums", nums);
      document.getElementById("i").innerHTML = sessionStorage.getItem("nums");
      sessionStorage.setItem("topicCount", this.topicData.topicCount);
      document.getElementById("count").innerHTML =
        sessionStorage.getItem("topicCount");
      sessionStorage.setItem("topicCType", this.topicData.topicCType);
      sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
    },
    // 获取练习题数据
    async startExercise() {
      const startRes = await api.startExercise({
        m_id: sessionStorage.getItem("m_id"),
      });
      console.log("练习题数据", startRes);
      // 阅读题判断
      const isRead = startRes.data.data.c_id;
      if (isRead == 9) {
        this.isRead = false;
      }
      if (startRes.data.code === 0) {
        this.topicData = startRes.data.data;
        this.tableData = this.topicData.topic.answer.map((item, index) => {
          return {
            english: this.english[index],
            value: item,
          };
        });
        let nums = this.topicData.index;
        const q_id = this.topicData.topic.id;
        if (this.topicData.sortlist) {
          for (const item of this.topicData.sortlist) {
            if (item.indexOf(q_id) > -1) {
              nums = item.indexOf(q_id) + 1;
            }
          }
        }
        sessionStorage.setItem("q_id", q_id);
        sessionStorage.setItem("collect", this.topicData.topic.collect);
        sessionStorage.setItem("nums", nums);
        sessionStorage.setItem("isFirst", false);
        sessionStorage.setItem("topicCount", this.topicData.topicCount);
        document.getElementById("count").innerHTML =
          sessionStorage.getItem("topicCount");
        sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
      } else {
        this.$message.error(startRes.data.msg);
      }
    },
    async nextExerciseTopic() {
      let params = {
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
      };
      const startRes = await api.nextExercise(params);
      console.log("下一道练习题", startRes);
      // 阅读题判断
      const isRead = startRes.data.data.c_id;
      if (isRead == 9) {
        this.isRead = false;
      }
      if (startRes.data.code === 0) {
        this.topicData = startRes.data.data;
        this.tableData = this.topicData.topic.answer.map((item, index) => {
          return {
            english: this.english[index],
            value: item,
          };
        });
        let nums = this.topicData.index;
        const q_id = this.topicData.topic.id;
        if (this.topicData.sortlist) {
          for (const item of this.topicData.sortlist) {
            if (item.indexOf(q_id) > -1) {
              nums = item.indexOf(q_id) + 1;
            }
          }
        }
        sessionStorage.setItem("q_id", q_id);
        sessionStorage.setItem("collect", this.topicData.topic.collect);
        sessionStorage.setItem("nums", nums);
        document.getElementById("i").innerHTML = sessionStorage.getItem("nums");
        sessionStorage.setItem("isFirst", false);
        sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
        sessionStorage.setItem("topicCount", this.topicData.topicCount);
        document.getElementById("count").innerHTML =
          sessionStorage.getItem("topicCount");
      } else {
        this.$message.error(startRes.data.msg);
      }
    },
    radioChange() {
      if (this.answer.firstRadio.length > 1) {
        this.answer.firstRadio.splice(0, this.answer.firstRadio.length - 1);
      }
      if (this.answer.secondRadio.length > 1) {
        this.answer.secondRadio.splice(0, this.answer.secondRadio.length - 1);
      }
    },
    async getMockexam() {
      let startParams = {
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
        q_id: sessionStorage.getItem("q_id"),
      };
      const res = await api.getMockexam(startParams);
      console.log("开始考试", res);
      // 阅读题判断
      const isRead = res.data.data.c_id;
      if (isRead == 9) {
        this.isRead = false;
      }
      if (res.data.code === 0) {
        this.topicData = res.data.data;
        this.tableData = this.topicData.topic.answer.map((item, index) => {
          return {
            english: this.english[index],
            value: item,
          };
        });
        let nums = this.topicData.index;
        const q_id = this.topicData.topic.id;
        if (this.topicData.sortlist) {
          for (const item of this.topicData.sortlist) {
            if (item.indexOf(q_id) > -1) {
              nums = item.indexOf(q_id) + 1;
            }
          }
        }
        sessionStorage.setItem("q_id", q_id);
        sessionStorage.setItem("mark", this.topicData.mark);
        sessionStorage.setItem("collect", this.topicData.topic.collect);
        sessionStorage.setItem("nums", nums);
        sessionStorage.setItem("topicCType", this.topicData.topicCType);
        document.getElementById("i").innerHTML = sessionStorage.getItem("nums");
        sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
        sessionStorage.setItem("isFirst", false);
        this.$emit("changeReview");

        if (this.topicData.answer !== "0") {
          const answer = JSON.parse(this.topicData.answer);
          console.log(answer);
          answer.forEach((element) => {
            element % 2 == 0
              ? this.answer.firstRadio.push(element / 2)
              : this.answer.secondRadio.push((element - 1) / 2);
          });
          sessionStorage.setItem(
            "answer",
            JSON.stringify([this.topicData.answer.toString()])
          );
          sessionStorage.setItem("isAnswer", true);
        }
      }
    },
    async startAnswer() {
      let startParams = {
        m_id: sessionStorage.getItem("m_id"),
        // m_id:this.$route.params.id,
        id: this.$route.query.id,
      };
      const res = await api.startMockExam(startParams);
      console.log("开始考试", res);
      // 阅读题判断
      const isRead = res.data.data.c_id;
      if (isRead == 9) {
        this.isRead = false;
      }
      if (res.data.code === 0) {
        this.info(res);
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/doubleChoice.css";
</style>



// WEBPACK FOOTER //
// src/view/examinatSystem/doubleChoice.vue